import React from 'react'
import type { Listing } from '@adc/sdk/types'
// @ts-ignore no types
import { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import { Ribbon } from '../../elementals'
import { ColorNames } from '../../../constants/colorVars'

type ListingInfoCardRibbonProps = {
  listing: AuctionBlueprintOnlineReactiveArgs['listing'] | Listing
  statusLabelRole: {
    color: string
    icon: string
  }
}
export const ListingInfoCardRibbon = ({
  listing,
  statusLabelRole,
}: ListingInfoCardRibbonProps) => {
  const { color, icon } = statusLabelRole
  if (!listing?.listing_status_label || !statusLabelRole.color) return null
  return (
    <Ribbon
      color={color as ColorNames}
      size='large'
      style={{
        zIndex: 2,
      }}
      data-elm-id='ribbon'
    >
      <Ribbon.Content
        title={listing.listing_status_label}
        iconProps={{
          name: icon,
          color: 'white',
        }}
      />
    </Ribbon>
  )
}
